/** 汇率：改汇率（再确认一次）+ 历史。权限点 finance.fx_rate.manage（财务 + 老板）；接口 PUT /api/v1/finance/fx-rate。 */
import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fmtTime, sitePaymentsApi, type FxOverview } from "@/services/sitePayments";
import { Modal, errText } from "./ui";

export function FxDialogs({ mode, fx, onClose }: { mode: "edit" | "history"; fx: FxOverview; onClose: () => void }) {
  return mode === "edit" ? <EditFx current={fx.current?.rate ?? ""} onClose={onClose} /> : <FxHistory onClose={onClose} />;
}

function EditFx({ current, onClose }: { current: string; onClose: () => void }) {
  const qc = useQueryClient();
  const [rate, setRate] = useState(current);
  const [again, setAgain] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const m = useMutation({
    mutationFn: () => sitePaymentsApi.setFx(rate.trim(), again.trim()),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["site-payments"] }); qc.invalidateQueries({ queryKey: ["fx"] }); onClose(); },
    onError: (e) => setErr(errText(e)),
  });
  const ok = rate.trim() !== "" && rate.trim() === again.trim();
  return (
    <Modal title="改汇率" onClose={onClose}>
      <div className="text-[12.5px] text-slate-500">1 美元 = ？人民币</div>
      <input aria-label="新汇率" value={rate} onChange={(e) => setRate(e.target.value)} inputMode="decimal" className="rounded-lg border border-slate-300 px-2.5 py-2 text-[13.5px]" />
      <input aria-label="再输入一次确认" value={again} onChange={(e) => setAgain(e.target.value)} inputMode="decimal" placeholder="再输入一次确认" className="rounded-lg border border-slate-300 px-2.5 py-2 text-[13.5px]" />
      <div data-testid="fx-warn" className="rounded-lg bg-amber-50 px-2.5 py-2 text-[13px] text-amber-800">改完后<b>新下的单</b>按 {rate.trim() || "新汇率"} 算；已经下的单按下单时的汇率，不跟着变。</div>
      {err && <div className="text-[12.5px] text-rose-600">{err}</div>}
      <div className="flex justify-end gap-2">
        <button type="button" onClick={onClose} className="rounded-lg border border-slate-300 px-3 py-1.5 text-[13px]">取消</button>
        <button type="button" disabled={!ok || m.isPending} onClick={() => m.mutate()} className="rounded-lg bg-blue-600 px-3 py-1.5 text-[13px] font-semibold text-white disabled:opacity-40">确认改成 {rate.trim() || "…"}</button>
      </div>
    </Modal>
  );
}

function FxHistory({ onClose }: { onClose: () => void }) {
  const q = useQuery({ queryKey: ["fx", "history"], queryFn: sitePaymentsApi.fx });
  return (
    <Modal title="汇率历史" onClose={onClose}>
      <table className="w-full text-[13px]">
        <thead><tr className="text-left text-[12px] text-slate-400"><th className="py-1">生效时间</th><th>汇率</th><th>设定人</th></tr></thead>
        <tbody>
          {(q.data?.history ?? []).map((h, i) => <tr key={i} className="border-t border-slate-100"><td className="py-1.5 tabular-nums">{fmtTime(h.effective_at)}</td><td className="tabular-nums">{h.rate}</td><td>{h.set_by ?? "—"}</td></tr>)}
        </tbody>
      </table>
      {q.isLoading && <div className="text-[12.5px] text-slate-400">加载中…</div>}
      <div className="flex justify-end"><button type="button" onClick={onClose} className="rounded-lg border border-slate-300 px-3 py-1.5 text-[13px]">关闭</button></div>
    </Modal>
  );
}
